export class Payer {
  name: string;
  surname: string;
  email: string;
  mobile: string;
  city: string;
  street: string;
  postalCode: string;
  countryCode: string;
  symbol: string;
}
